<template>
  <div class="cesiumContainer" ref="viewer">
    <div id="coords" class="location-bar"></div>
  </div>
</template>
<script>
import { icons } from "../config/constant";
import { appConfig } from "../config/mapConfig";

import centerOfMass from "@turf/center-of-mass";

import h337 from "heatmap.js";

const heleprs = require("@turf/helpers");

let isEnter = false;
export default { 
  data() {
    return {
      rotate: false,
      modelConfigArray: appConfig.supermap.modelPointArray || [],
      model3DArray: [],
      isShowMousePosition: false, //显示鼠标位置
      vectorLayers: null,
      vectorLogLayer: null,
      imgs: {
        img_poi: icons.all,
      },
      popupArray: [],
      polygonCenterArray: [],
    };
  },
  methods: {
    /**
     * 初始化定位至某点
     * @param {Number} longitude 经度
     * @param {Number} latitude  纬度
     * @param {Number} height    视野高度 默认1000
     * @param {Number} heading   朝向角 默认0
     * @param {Number} pitch     俯仰角 默认-90
     *
     */
    initLocation({
      longitude,
      latitude,
      height = 5000,
      heading = 0,
      pitch = 90,
    }) {
      console.log("longitude")
      console.log(latitude)
      console.log(longitude)
      var tdtKey = "2275c70eb3216152e357bb25b5959695";
      console.log(viewer, "viewer");
      if (!!window.viewer) {
        window.viewer.destroy();
        window.viewer = null;
      }
      let viewer = new Cesium.Viewer(this.$refs.viewer, {
        selectionIndicator: false,
        infoBox: false,
      });

      window.viewer = viewer;
      let scene = viewer.scene;
      window.scene = scene;

      let widget = viewer.cesiumWidget;
      window.widget = widget;

      // viewer.scene.globe.depthTestAgainstTerrain = false
      viewer.scene.debugShowFramesPerSecond = false; //帧率是否显示
      viewer.scene.globe.depthTestAgainstTerrain = false; //解决Cesium绘制几何图形被高程遮挡问题
      viewer.scene.undergroundMode = false; //是否开启地下场景
      viewer.scene.screenSpaceCameraController.minimumZoomDistance = 10; //设置相机最小缩放距离,距离地表10米
      viewer._cesiumWidget._creditContainer.style.display = "none"; //隐藏logo

      var imageryLayers = viewer.imageryLayers;
      imageryLayers.addImageryProvider(
        new Cesium.TiandituImageryProvider({
          credit: new Cesium.Credit("天地图全球影像服务"),
          token: tdtKey,
        })
      );

      //影像数据
      imageryLayers.addImageryProvider(
        new Cesium.SuperMapImageryProvider({
          url: appConfig.supermap.sceneURL,
        })
      );

      //初始化天地图全球中文注记服务，并添加至影像图层
      // var labelImagery = new Cesium.TiandituImageryProvider({
      //   mapStyle: Cesium.TiandituMapsStyle.CIA_C, //天地图全球中文注记服务（经纬度投影）
      //   token: tdtKey,
      // });
      // imageryLayers.addImageryProvider(labelImagery);

      this.setTerrainVisible(true); //默认加载地形
      // this.addMousePosition();//鼠标位置

      this.initMouseClickEvent();
      this.initMouseMoveEvent();
      //  this.initMouseOverEvent();
      //初始化天地图全球矢量地图服务（经纬度投影）。
      var vectorImagery = new Cesium.TiandituImageryProvider({
        mapStyle: Cesium.TiandituMapsStyle.VEC_C,
        token: tdtKey,
      });
      let vectorLayers = imageryLayers.addImageryProvider(vectorImagery);
      //初始化天地图全球矢量地图标注服务（经纬度投影）。
      var vectorLogImagery = new Cesium.TiandituImageryProvider({
        mapStyle: Cesium.TiandituMapsStyle.CVA_W,
        token: tdtKey,
      });
      let vectorLogLayer = imageryLayers.addImageryProvider(vectorLogImagery);

      //开启进入动画
      this.enterAnimate(longitude, latitude, height, heading);
      this.vectorLayers = vectorLayers;
      this.vectorLogLayer = vectorLogLayer;
      vectorLogLayer.show = false;
      vectorLayers.show = false;
    },
    getCenterPosition() {
      var result = viewer.camera.pickEllipsoid(
        new Cesium.Cartesian2(
          viewer.canvas.clientWidth / 2,
          viewer.canvas.clientHeight / 2
        )
      );
      var curPosition = Cesium.Ellipsoid.WGS84.cartesianToCartographic(result);
      var lon = (curPosition.longitude * 180) / Math.PI;
      var lat = (curPosition.latitude * 180) / Math.PI;
      console.log(lon, lat, "location");
      //打印相机heading/peath/roll

      //获取相机参数时，也要用Cesium.Math.toDegrees函数，用和不用出来结果不相同的。直接拿来用setViewer，建议用//Cesium.Math.toDegrees

      var camera = viewer.camera;
      const heading = Cesium.Math.toDegrees(viewer.camera.heading);
      const pitch = Cesium.Math.toDegrees(viewer.camera.pitch); //Cesium.Math.toDegrees作用是把弧度转换成度数Cesium.Math.toDegrees(viewer.camera.roll)
      console.log(camera, heading, pitch, "camera"); //相机对像，heading,pitch,height都有都可打印

      //当前相机高度

      const height = viewer.camera.positionCartographic.height;
      console.log(height, "height");
      return { lon, lat, height, heading, pitch };
    },

    // 显示矢量图层
    showVector() {
      if (this.vectorLayers) {
        this.vectorLayers.show = true;
      }
      if (this.vectorLogLayer) {
        this.vectorLogLayer.show = true;
      }
    },
    // 隐藏矢量图层
    hideVector() {
      if (this.vectorLayers) {
        this.vectorLayers.show = false;
      }
      if (this.vectorLogLayer) {
        this.vectorLogLayer.show = false;
      }
    },
    /**
     * 地形图层显隐控制
     * @param {Boolean} value
     */
    setTerrainVisible(value) {
      if (value == true) {
        viewer.terrainProvider = new Cesium.CesiumTerrainProvider({
          url: appConfig.supermap.terrainURL,
          isSct: true, //地形服务源自SuperMap iServer发布时需设置isSct为true
        });
      } else {
        viewer.terrainProvider = new Cesium.EllipsoidTerrainProvider({});
      }
    },
    removeAllMarkes() {
      viewer.entities.removeAll();
    },
    /**
     * 进入动画（地球自转，定位至某点）
     * @param {Number} lon 经度 wgs84
     * @param {Number} lat 纬度 wgs84
     * @param {Number} height 视角高度
     * @param {Number} heading 朝向角
     * @param {Number} pitch 俯仰角
     */
    enterAnimate(
      lon = 88.127965771,
      lat = 43.885640247,
      height = 1000,
      heading = 0,
      pitch = -30
    ) {
      Cesium.Camera.DEFAULT_VIEW_FACTOR = 1.6;
      Cesium.Camera.DEFAULT_VIEW_RECTANGLE = Cesium.Rectangle.fromDegrees(
        0,
        -40,
        20,
        40
      ); //west south east north
      var center = Cesium.Cartesian3.fromDegrees(lon, lat, height);

      var i = Date.now();
      function rotate() {
        var a = 0.1;
        var t = Date.now();
        var n = (t - i) / 1e3;
        i = t;
        viewer.scene.camera.rotate(Cesium.Cartesian3.UNIT_Z, -a * n);
      }

      viewer.scene.sun.destroy(); //去掉太阳
      viewer.scene.sun = undefined; //去掉太阳
      viewer.scene.moon.destroy(); //去掉月亮
      viewer.scene.moon = undefined; //去掉月亮
      viewer.scene.backgroundColor = Cesium.Color.TRANSPARENT;

      var that = this;
      viewer.clock.onTick.addEventListener(rotate);
      viewer.clock.multiplier = 200; //速度
      setTimeout(function () {
        viewer.clock.onTick.removeEventListener(rotate);
        that.flyToPoint(lon, lat, height, heading, pitch, 0, 3, function () {
          that.add3DModelArray(that.modelConfigArray);
          that.$emit("mapLoaded");
          viewer.camera.setView({
            destination: center,
            orientation: {
              // 指向
              heading: Cesium.Math.toRadians(heading),
              // 视角
              pitch: Cesium.Math.toRadians(pitch),
              roll: 0.0,
            },
          });
        });
      }, 5000);
    },
    /**
     * 3D模型数组添加
     */
    add3DModelArray(modelArray) {
      var that = this;
      setTimeout(() => {
        if (modelArray.length > 0) {
          for (let i = 0; i < modelArray.length; i++) {
            that.add3DModel(modelArray[i]);
          }
          // that.add3DModel(modelArray[0]);
        }
      }, 1000);
    },
    /**
     * 三维模型加载
     * @param {Object} item  三维模型
     * @param {String} item.code  code 唯一
     * @param {String} item.name  名称
     * @param {Number} item.longitude  中心点经度
     * @param {Number} item.latitude   中心点纬度
     * @param {Number} item.height     视角高度
     * @param {Number} item.heading    朝向角
     * @param {Number} item.pitch      俯仰角
     * @param {String} bgUrl           倾斜摄影背景
     * @param {String} modelUrl        三维模型
     */
    add3DModel(item) {
      // item={
      //     code:'fushouguan',
      //     name:'福寿观',
      //     longitude:88.1130555555555,
      //     latitude:43.8947222222222,
      //     height:2500,
      //     heading:239,
      //     pitch:-25,
      //     bgUrl:'http://localhost:8090/iserver/services/3D-local3DCache-Data2/rest/realspace/datas/c5_bg/config',
      //     modelUrl:'http://localhost:8090/iserver/services/3D-local3DCache-Data/rest/realspace/datas/c5_model/config'
      // }
      if (item.bgUrl && item.bgUrl.length > 0) {
        var promise = scene.addS3MTilesLayerByScp(item.bgUrl, {
          name: "s3m_bg_" + item.code,
          //cacheKey: ""  //三维缓存密钥，由SuperMap iServer设置和获取
        });
        promise.then(function (layer) {
          layer.visible = true;
          console.log(item.name + " bg 加载完成");
        });
      }
      if (item.modelUrl && item.modelUrl.length > 0) {
        var promise = scene.addS3MTilesLayerByScp(item.modelUrl, {
          name: "s3m_model_" + item.code,
          //cacheKey: ""  //三维缓存密钥，由SuperMap iServer设置和获取
        });
        promise.then(function (layer) {
          layer.visible = true;
          console.log(item.name + " model 加载完成");
        });
      }
      console.log("模型加载：", item);
    },
    /**
     *
     */
    set3DModelVisible(value) {
      if ((value = true)) {
        var promise = scene.addS3MTilesLayerByScp(
          "http://localhost:8090/iserver/services/3D-local3DCache-Data/rest/realspace/datas/c5_model/config",
          {
            name: "base",
            //cacheKey: ""  //三维缓存密钥，由SuperMap iServer设置和获取
          }
        );
        promise.then(function (layer) {
          layer.visible = true;
        });
      } else {
      }
    },
    /**
     * 添加鼠标位置信息
     * @param {string} coordsID 状态栏ID
     */
    addMousePosition(coordsID = "coords") {
      var that = this;
      //鼠标位置
      var handler = new Cesium.ScreenSpaceEventHandler(scene.canvas);
      handler.setInputAction(function (movement) {
        if (!that.isShowMousePosition) {
          return;
        }

        var ellipsoid = scene.globe.ellipsoid;
        var cartesian = scene.camera.pickEllipsoid(
          movement.endPosition,
          ellipsoid
        );
        if (cartesian) {
          var cartographic = ellipsoid.cartesianToCartographic(cartesian);
          var coords =
            "经度:" +
            that.formatDegree(Cesium.Math.toDegrees(cartographic.longitude)) + //.toFixed(2)
            ",纬度:" +
            that.formatDegree(Cesium.Math.toDegrees(cartographic.latitude)) + //.toFixed(2)
            ",海拔:" +
            viewer.scene.globe.getHeight(cartographic).toFixed(2) +
            "m" +
            ",视角高度:" +
            Math.ceil(viewer.camera.positionCartographic.height) +
            "m" +
            ",朝向角:" +
            Cesium.Math.toDegrees(viewer.camera.heading).toFixed(2) +
            "°" +
            ",仰角:" +
            Cesium.Math.toDegrees(viewer.camera.pitch).toFixed(2) +
            "°";
          document.getElementById(coordsID).innerHTML = coords;
          document.getElementById(coordsID).style.display = "";
        } else {
          document.getElementById(coordsID).style.display = "none";
        }
      }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
    },
    /**
     * 设置鼠标位置显隐
     * @param {Boolean} value
     */
    setMousePositionVisible(value) {
      this.isShowMousePosition = value;
    },
    /**
     * @description: 飞行定位到一个经纬度
     * @param {Number} longitude 经度
     * @param {Number} latituded 纬度
     * @param {Number} heading  默认=0.0   偏航角 正北,由正北向东偏向为正
     * @param {Number} pitch  =-90     俯仰角 垂直向下， ENU局部坐标系中XY平面的旋转角度，平面下为负，上为正，
     * @param {Number} range    =0.0   距目标点距离
     * @param {Number} duration =3   持续时间
     * @param {Function} callBack =null   回调函数，定位完成后执行
     */
    flyToPoint(
      longitude,
      latitude,
      height,
      heading = 0.0,
      pitch = -90,
      range = 0.0,
      duration = 3,
      callBack = null
    ) {
      if (!viewer) {
        console.log("三维球未初始化！");
        return;
      }
      var destination = Cesium.Cartesian3.fromDegrees(
        longitude,
        latitude,
        height
      );
      if (!destination) {
        console.log("定位目标点不对！");
        return;
      }
      var boundingSphere = new Cesium.BoundingSphere(destination, 0.0);
      viewer.camera.flyToBoundingSphere(boundingSphere, {
        duration: duration,
        maximumHeight: undefined,
        complete: function () {
          if (callBack) {
            callBack();
          } else {
            console.log("定位失败！");
          }
        },
        cancel: function () {
          console.log("定位取消！");
        },
        offset: {
          heading: Cesium.Math.toRadians(heading),
          pitch: Cesium.Math.toRadians(pitch),
          range: range,
        },
      });
    },
    /**
     * 二三维场景切换
     * @param {String} value 2D/3D/2.5D
     */
    switchMapType(value) {
      if (value == "2D") {
        viewer.scene.mode = Cesium.SceneMode.SCENE2D; //平面场景
      } else if (value == "3D") {
        viewer.scene.mode = Cesium.SceneMode.SCENE3D; //3D情况下
        this.setTerrainVisible(true); //加载地形
      } else if (value == "2.5D") {
        viewer.scene.mode = Cesium.SceneMode.COLUMBUS_VIEW; //哥伦布视图
      }
    },
    /**
     * 根据id移除实体对象
     * @param {String} id 实体id 创建时传入
     */
    removeEntityById(id) {
      var curEntity = viewer.entities.getById(id);
      if (curEntity) {
        viewer.entities.remove(curEntity);
      }
    },
    /**
     * 绘制点
     * @param {String} id 实体对象id  唯一
     * @param {Number} lon 经度   wgs84坐标
     * @param {Number} lat 纬度
     * @param {String} name 名称
     * @param {String} img 图标
     * @param {String} description 描述
     */
    renderPoint({
      id,
      lon = 88.1202777777778,
      lat = 43.8997222222222,
      name = "名称",
      img,
      width = 176,
      height = 140,
      showLabel = false,
    }) {
      return viewer.entities.add({
        id: "poi|" + id,
        position: Cesium.Cartesian3.fromDegrees(lon, lat), //88.1202777777778,43.8997222222222
        billboard: {
          image: img, //图标
          heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
          width, //宽度  不设置默认用图片的宽度
          height, //高度
        },
        //  point: {
        //     color: Cesium.Color.RED,    //点位颜色
        //     pixelSize: 10 ,               //像素点大小
        //     heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,  //贴地
        //  },
        label: {
          text: name,
          font: "14pt Source Han Sans CN", //字体样式
          fillColor: Cesium.Color(1, 1, 1, 1), //字体颜色
          backgroundColor: Cesium.Color(0.3, 0.3, 0.3, 1), // .AQUA,    //背景颜色
          showBackground: true, //是否显示背景颜色
          style: Cesium.LabelStyle.FILL, //label样式
          outlineWidth: 2,
          verticalOrigin: Cesium.VerticalOrigin.TOP, //垂直位置  BOTTOM  TOP CENTER
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER, //水平位置  CENTER  LEFT
          pixelOffset: new Cesium.Cartesian2(0, -50), //偏移  x水平   y 向下为正
          heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
          disableDepthTestDistance: Number.POSITIVE_INFINITY,
          show: showLabel,
        },
      });

      //viewer.zoomTo(e);

      //经纬度坐标转世界坐标
      //var htmlContent="<div>"+name+"</div>"
      //this.renderPopup(id,lon,lat,htmlContent);

      //世界坐标转屏幕坐标
    },
    /**
     * 移除点
     * @param {String} id 点位id
     */
    removePoint(id) {
      this.removeEntityById("poi|" + id);
    },
    /**
     * 绘制线
     * @param {String} id 线实体id  唯一
     * @param {Array} pointArray 点位数组 [lon1,lat1,lon2,lat2...]
     * @param {Object} options 线参数
     * @param {Number} options.width 线宽度 默认为5
     * @param {Number} options.outlineWidth  线边界宽度 默认为2
     * @param {Object} options.lineColor     线填充颜色
     * @param {Object} options.outlineColor  线边界颜色
     */
    renderPolyline(id, pointArray, options) {
      var fillColor = new Cesium.Color();
      var outlineColor = new Cesium.Color();

      Cesium.Color.fromBytes(red, green, blue, alpha, fillColor);
      Cesium.Color.fromBytes(red, green, blue, alpha, outlineColor);

      var lineEntity = viewer.entities.add({
        id: "polyline|" + id,
        polyline: {
          positions: Cesium.Cartesian3.fromDegreesArray(pointArray),
          clampToGround: true,
          width: options.width ? options.width : 5,
          material: new Cesium.PolylineOutlineMaterialProperty({
            color: Cesium.Color.ORANGE,
            outlineWidth: options.outlineWidth ? options.outlineWidth : 2,
            outlineColor: Cesium.Color.BLACK,
          }),
        },
      });
    },
    /**
     * 移除线
     * @param {String} id 线实体id
     */
    removePolyline(id) {
      this.removeEntityById("polyline|" + id);
    },
    /**
     * 绘制面
     * @param {String} id 线实体id  唯一
     * @param {Array} pointArray 点位数组 [lon1,lat1,lon2,lat2...]
     * @param {Object} options 线参数
     * @param {Number} options.width 线宽度 默认为5
     * @param {Number} options.outlineWidth  线边界宽度 默认为2
     * @param {Object} options.lineColor     线填充颜色
     * @param {Object} options.outlineColor  线边界颜色
     * @param {String} name 线实体id label名称
     * @param {Boolean} showLable true 显示label
     */
    renderPolygon({ id, pointArray, options, name, showLabel, lableOptions }) {
      var polygonEntitys = viewer.entities.add({
        id: "polygon|" + id,
        polygon: {
          hierarchy: new Cesium.PolygonHierarchy(
            Cesium.Cartesian3.fromDegreesArray(pointArray)
          ),
          material: options.materialColor || Cesium.Color.RED.withAlpha(0.5),
          classificationType: Cesium.ClassificationType.BOTH,
          outline: true,
          outlineColor: new Cesium.Color(0, 0, 1, 0.5),
          fill: true,
        },
      });

      if (showLabel) {
        var value = [];
        var center = [];
        var a = 0;
        var b = 0;
        for (
          var j = 0;
          j <= polygonEntitys.polygon._hierarchy._value.positions.length - 1;
          j++
        ) {
          value[j] = [
            polygonEntitys.polygon._hierarchy._value.positions[j].x,
            polygonEntitys.polygon._hierarchy._value.positions[j].y,
          ];
          a = polygonEntitys.polygon._hierarchy._value.positions[j].z;
          b = b + a;
        }
        //  center = centerOfMass(heleprs.polygon([value])).geometry.coordinates;
        // var labelpostion = Cesium.Cartesian3.fromArray(center);

        var polygon = heleprs.polygon([value]);
        var centroids = centerOfMass(polygon);
        center = [
          centroids.geometry.coordinates[0],
          centroids.geometry.coordinates[1],
          b / polygonEntitys.polygon._hierarchy._value.positions.length + 1000,
        ];
        var labelpostion = Cesium.Cartesian3.fromArray(center);
        //为了解决label重叠的问题,计算中心点的距离，如果距离<100米，则设置label偏移
        var ellipsoid = viewer.scene.globe.ellipsoid;
        var cartographic = ellipsoid.cartesianToCartographic(labelpostion);
        var lat = Cesium.Math.toDegrees(cartographic.latitude);
        var lng = Cesium.Math.toDegrees(cartographic.longitude);
        var start = Cesium.Cartesian3.fromDegrees(lng, lat);
        let offsety = 0;
        if (window.polygonCenterArray.length > 0) {
          for (let d = 0; d < window.polygonCenterArray.length; d++) {
            var cartographice = ellipsoid.cartesianToCartographic(
              window.polygonCenterArray[d]
            );
            var late = Cesium.Math.toDegrees(cartographice.latitude);
            var lnge = Cesium.Math.toDegrees(cartographice.longitude);
            let end = Cesium.Cartesian3.fromDegrees(lnge, late);
            let distance = Cesium.Cartesian3.distance(start, end);
            if (distance < 100) {
              offsety = 18;
              break;
            }
          }
        }

        window.polygonCenterArray.push(labelpostion);
        polygonEntitys.position = labelpostion;
        polygonEntitys.label = {
          // position:
          text: name,
          color: Cesium.Color.fromCssColorString("#fff"),
          font: "normal 32px MicroSoft YaHei",
          showBackground: true,
          scale: 0.5,
          horizontalOrigin: Cesium.HorizontalOrigin.LEFT_CLICK,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          disableDepthTestDistance: 10000.0,
          pixelOffset: new Cesium.Cartesian2(lableOptions.offsetx, offsety), //偏移  x水平   y 向下为正
        };
      }
    },
    /**
     * 移除面
     * @param {String} id 面实体id 唯一
     */
    removePolygon(id) {
      this.removeEntityById("polygon|" + id);
    },
    /**
     * 鼠标点击事件
     */
    initMouseClickEvent() {
      var that = this;
      var handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
      var _position, _pm_position, _cartesian;

      handler.setInputAction(function onLeftClick(movement) {
        var worldPosition = scene.pickPosition(movement.position); //单击位置
        var pickedFeature = viewer.scene.pick(movement.position);
        const { x, y } = movement.position;
        if (!Cesium.defined(pickedFeature)) {
          return;
        }
        that.$emit("mouseClickObject", {
          id: pickedFeature.id.id,
          location: worldPosition,
          x: parseInt(x),
          y: parseInt(y),
        });
      }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
    },
    /**
     * 鼠标移动
     */
    initMouseMoveEvent() {
      var that = this;
      var handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
      handler.setInputAction(function (movement) {
        if (scene.mode !== Cesium.SceneMode.MORPHING) {
          var worldPosition = scene.pickPosition(movement.endPosition); //单击位置
          var pickedFeature = viewer.scene.pick(movement.endPosition);
          const { x, y } = movement.endPosition;
          if (!Cesium.defined(pickedFeature)) {
            if (isEnter) {
              console.log(movement, pickedFeature, "mouse leave");
              that.$emit("entitieMouseLeave", {
                pickedFeature,
                worldPosition,
                x,
                y,
              });
              isEnter = false;
            }
          } else {
            if (!isEnter) {
              isEnter = true;
              console.log(movement, pickedFeature, "mouse enter");
              that.$emit("entitieMouseEnter", {
                pickedFeature,
                worldPosition,
                x,
                y,
              });
            }
          }
        }
      }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
    },

    /**
     * 鼠标悬浮
     */
    initMouseOverEvent() {
      var that = this;
      var handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
      handler.setInputAction(function (movement) {
        var haveEn = viewer.scene.pick(movement.endPosition);
        if (
          viewer.scene.pickPositionSupported &&
          Cesium.defined(haveEn) &&
          haveEn.id !== " "
        ) {
          clearAlpha();
          if (haveEn.id.polygon !== undefined) {
            var haveEnsNow = haveEn.id.polygon._material._color.getValue();
            haveEnsNow.alpha = 1;
            haveEn.id.polygon._material._color.setValue(haveEnsNow);
            that.$emit("entitieMouseOver", {});
          }
        } else if (haveEn == undefined) {
          clearAlpha();
        }
      }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
      function clearAlpha() {
        for (var i = 0; i < viewer.entities.values.length; i++) {
          if (viewer.entities.values[i].name == "yanse") {
            var haveEnsLast =
              viewer.entities.values[i]._polygon._material._color.getValue();
            haveEnsLast.alpha = 0.2;
            viewer.entities.values[i]._polygon._material._color.setValue(
              haveEnsLast
            );
          }
        }
      }
    },

    highlightPolygonEntity(id) {
      let heightEntity = null;
      heightEntity = viewer.entities.getById("highlight|" + id);
      if (heightEntity) {
        viewer.entities.remove(heightEntity);
      }
      if (!id) {
        return;
      }
      let e = viewer.entities.getById(id);
      if (e) {
        var haveEnsNow = e.polygon._material._color.getValue();
        haveEnsNow.alpha = 1;
        heightEntity = viewer.entities.add({
          id: "highlight|" + id,
          polyline: {
            positions: e.polygon.hierarchy.getValue().positions,
            width: 10,
            material: new Cesium.PolylineGlowMaterialProperty({
              glowPower: 0.5, // 一个数字属性，指定发光强度，占总线宽的百分比。
              color: haveEnsNow,
            }),
            clampToGround: true,
          },
        });
      }
    },
    removeHighlightPolygonEntity(id) {
      let heightEntity = null;
      heightEntity = viewer.entities.getById("highlight|" + id);
      if (heightEntity) {
        viewer.entities.remove(heightEntity);
      }
      if (!id) {
        return;
      }
    },
    /* 计算两点之间的距离 */
    getDistance(satrt, end) {
      var geodesic = new Cesium.EllipsoidGeodesic();
      geodesic.setEndPoints(satrt, end);
      var distance = geodesic.surfaceDistance;
      return distance;
    },

    renderHeatMap(heatData) {
      console.log("开始构建热力图");
      console.log("热力数据：", heatData);
      if (heatData && heatData.length > 0) {
        var coordinate = this.getCoordinate(heatData);
        // let data1 = this.getData(1000);
        var heatMap1 = this.createHeatMap(
          100,
          this.getHeatData(heatData, coordinate)
        );
        this.createRectangle(viewer, coordinate, heatMap1);
      }
    },

    removeHeatMap() {
      console.log("开始移除热力图");
      let heightEntity = null;
      heightEntity = viewer.entities.getById("heatmap");
      if (heightEntity) {
        viewer.entities.remove(heightEntity);
      }
    },

    /**
     *  创建热力图
     * @param {Cesium.Viewer} viewer Cesium.Viewer对象
     * @param {Array} coordinate 热力图范围经纬度
     * @param {Heatmap} heatMap 热力图对象
     */
    createHeatMap(max, data) {
      // 创建元素
      var heatDoc = document.createElement("div");
      heatDoc.setAttribute(
        "style",
        "width:1000px;height:1000px;margin: 0px;display: none;"
      );
      document.body.appendChild(heatDoc);
      // 创建热力图对象
      var heatmap = h337.create({
        container: heatDoc,
        radius: 30,
        maxOpacity: 1.0,
        minOpacity: 0.5,
        blur: 0.75,
        gradient: {
          0.8: "red",
          0.6: "orange",
          0.4: "yellow",
          // 0.5: "blue",
          0.2: "green",
        },
      });
      // 添加数据
      heatmap.setData({
        max: max,
        data: data,
      });
      return heatmap;
    },

    /**
     *  viewer上绑定热力图
     * @param {Cesium.Viewer} viewer Cesium.Viewer对象
     * @param {Array} coordinate 热力图范围经纬度
     * @param {Heatmap} heatMap 热力图对象
     */
    createRectangle(viewer, coordinate, heatMap) {
      viewer.entities.add({
        id: "heatmap",
        name: "Rotating rectangle with rotating texture coordinate",
        show: true,
        rectangle: {
          coordinates: Cesium.Rectangle.fromDegrees(
            coordinate[0],
            coordinate[1],
            coordinate[2],
            coordinate[3]
          ),
          material: heatMap._renderer.canvas, // 核心语句，填充热力图
        },
      });
    },

    /**
     * 获取热力图范围经纬度
     * @param {Array} locations 热力坐标数据
     * @returns {Array} 热力图范围经纬度
     */
    getCoordinate(locations) {
      let [lon, lat] = locations[0].poi.split(",").map((item) => Number(item));
      let west = lon,
        south = lat,
        east = lon,
        north = lat,
        margin = 0.1;

      // 获取所有点位的范围
      locations.forEach((item) => {
        let [lon, lat] = item.poi.split(",").map((item) => Number(item));
        if (lon < west) west = lon;
        if (lon > east) east = lon;
        if (lat < south) south = lat;
        if (lat > north) north = lat;
      });
      // 范围扩大
      west -= margin;
      east += margin;
      south -= margin;
      north += margin;

      // console.log("热力图范围1：", [west, south, east, north]);
      // 范围扩展正正方形
      let centerLoc = (west + east) * 0.5,
        centerlat = (south + north) * 0.5,
        range = Math.max(east - west, north - south) * 0.5;
      let coordinate = [
        centerLoc - range,
        centerlat - range,
        centerLoc + range,
        centerlat + range,
      ];
      // console.log("热力图范围2：", coordinate);

      return coordinate;
    },

    /**
     * 获取热力图渲染数据
     * @param {Array} data 热力数据
     * @param {Array} coordinate 热力图范围经纬度
     * @returns {Array} 热力图渲染数据
     */
    getHeatData(data, coordinate) {
      let heatData = [];
      let [west, south, east, north] = coordinate;
      data.forEach((item) => {
        let [lon, lat] = item.poi.split(",").map((item) => Number(item));
        let x = Math.floor(((lon - west) / (east - west)) * 1000),
          y = Math.floor(((north - lat) / (north - south)) * 1000);
        heatData.push({
          x,
          y,
          value: item.density,
        });
      });
      return heatData;
    },

  },
  destroyed() {},
};
</script>
<style scoped>
.cesiumContainer {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
}

/*鼠标状态栏*/
.location-bar {
  position: absolute;
  bottom: 0px;
  z-index: 991;
  /* padding: 3px 10px; */
  font-size: 13px;
  color: #e9e9e9;
  text-shadow: 2px 2px 2px #000;
  background-color: rgba(0, 0, 0, 0.4);
}
</style>